import { render, staticRenderFns } from "./DistrictBasedResources.vue?vue&type=template&id=753a5f07&scoped=true"
import script from "./DistrictBasedResources.vue?vue&type=script&lang=js"
export * from "./DistrictBasedResources.vue?vue&type=script&lang=js"
import style0 from "./DistrictBasedResources.vue?vue&type=style&index=0&id=753a5f07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753a5f07",
  null
  
)

export default component.exports